import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class InternalNotesMapperError extends IncError {
    constructor() {
        super(i18n.t("error:beneficiary.internalNotes.mapperError"));

        Object.setPrototypeOf(this, InternalNotesMapperError.prototype);
    }
}